export default __webpack_public_path__ + "static/media/home1.c5c0c6af.png";